import { Roadmap } from "@bkry/bowline-components/Roadmap";
import PropTypes from "prop-types";
import React from "react";

const LootboxRoadmap = () => {
  return (
    <div
      style={{
        backgroundImage: `url('/ethee_bg.png')`,
        backgroundPosition: "right center",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Roadmap roadmapSlug="lootbox-roadmap" />
    </div>
  );
};

/**  define proptype for the 'translation' function  */
LootboxRoadmap.contextTypes = {
  t: PropTypes.func,
};

/** export the component as redux connected component */
export default LootboxRoadmap;
